// Welche Angebote dieser Shop hat (Leasing, Bikmo, Packstation, easyCredit, Ratepay).
// reference: [oxid-proxy services/shop/angebote 1] — der Proxy entscheidet, die App folgt nur.
import {query} from './graphqlClient.js';

const QUERY = `query ShopAngebote { shopAngebote { leasing bikmo packstation easycredit ratepay } }`;

// Bis zur Antwort alles an: die Zahlungsarten und Bikmo filtert der Proxy ohnehin selbst,
// betroffen ist nur die Packstation-Auswahl, und die steht erst im Kontaktschritt.
const angebote = $state({leasing: true, bikmo: true, packstation: true, easycredit: true, ratepay: true, geladen: false});

let laufend = null;

export function ladeAngebote() {
    laufend ??= query(QUERY).then((r) => {
        Object.assign(angebote, r?.shopAngebote ?? {}, {geladen: true});
    }).catch(() => {
        laufend = null;
    });
    return laufend;
}

export {angebote};
